module.exports = __webpack_public_path__ + "afa853ffb8bc5b72c6dc9e0bc2140dfe.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/visnu-pitiyanuvath.jpg
 ** module id = 431
 ** module chunks = 0
 **/